// Generated by scripts/update-seeq-icons.js from src/svg/seeq/bar-chart.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcBarChart = {
  prefix: 'fak',
  iconName: 'bar-chart' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f934',
    'M117.8 911.4v-890.9c0-10.2-10.2-20.5-20.5-20.5h-76.8c-10.2 0-20.5 10.2-20.5 20.5v947.2c0 30.7 25.6 56.3 56.3 56.3h947.2c10.2 0 20.5-10.2 20.5-20.5v-76.8c0-10.2-10.2-20.5-20.5-20.5h-885.7zM358.4 547.8h-102.4c-30.7 0-51.2 20.5-51.2 51.2v230.4c0 15.4 10.2 25.6 25.6 25.6h153.6c15.4 0 25.6-10.2 25.6-25.6v-230.4c0-30.7-20.5-51.2-51.2-51.2zM619.5 87h-102.4c-30.7 0-51.2 20.5-51.2 51.2v686.1c0 15.4 10.2 25.6 25.6 25.6h153.6c15.4 0 25.6-10.2 25.6-25.6v-686.1c0-30.7-20.5-51.2-51.2-51.2zM880.6 384h-102.4c-30.7 0-51.2 20.5-51.2 51.2v389.1c0 15.4 10.2 25.6 25.6 25.6h153.6c15.4 0 25.6-10.2 25.6-25.6v-389.1c0-30.7-20.5-51.2-51.2-51.2z',
  ],
} satisfies IconDefinition;
